<template>
    <teleport to="body">
        <div
            class="pl-2 z-100 relative"
            :style="popupPosition"
            @mouseenter="onMouseenter"
        >
            <div class="w-40.5 p-2 bg-popUp-purple60 dark:bg-popUp-blue770 rounded-1.25">
                <div>
                    <div
                        class="flex items-center cursor-pointer"
                        v-for="sub in route.subMenu"
                        :key="sub.name"
                    >
                        <router-link
                            :to="{ name: sub.routeName, params: getParams(sub.paramsNames) }"
                            class="font-sans-rubik w-full p-2 font-normal text-xs rounded-1.25 whitespace-nowrap"
                            :class="[ checkCurrentLink(sub) ? 'text-gray-600 dark:text-purple-140' : 'text-gray-370 dark:text-gray-110 hover:text-gray-600 dark:hover:text-white hover:bg-menu-purple70 dark:hover:bg-popUp-blue600' ]"
                            @click.stop
                        >
                            {{ sub.name }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script setup>
import { useRouterStore } from '@/store/routerStore'

import { useRoutingMenu } from '@/composables/useRoutingMenu'

const props = defineProps({
    route: {
        type: Object,
        default: () => ({}),
    },
    popupPosition: {
        type: Object,
        default: () => ({}),
    },
})

const { checkCurrentLink } = useRoutingMenu()

const emits = defineEmits(['onMouseenter', 'onMouseClick'])

const routerStore = useRouterStore()

function getParams(paramsNames) {
    return routerStore.getParams(paramsNames)
}

function onMouseenter() {
    emits('onMouseenter', props.route.id)
}
</script>
